// @flow
import { getAppContext } from 'services/appContextService';
import useFortressQuery from './useFortressQuery';

export const getAppContextQueryKey = (organizationId, propertyId) => [
  'getAppContext',
  organizationId,
  propertyId,
];

const useAppContextQuery = ({
  organizationId,
  propertyId,
  ...queryOptions
} = {}) => {
  const queryKey = getAppContextQueryKey(organizationId, propertyId);

  return useFortressQuery({
    queryKey,
    queryFn: ({ signal }) =>
      getAppContext(organizationId, propertyId, { signal }),
    enabled: Boolean(organizationId && propertyId),
    refetchOnMount: 'always',
    staleTime: 0,
    ...queryOptions,
  });
};

export default useAppContextQuery;
